
import { factoryImages } from '../../../utils/images';

export default function OurFactoriesSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="text-gray-600 text-sm font-light tracking-[0.2em] uppercase mb-6">
            Manufacturing Excellence  
          </div>
          <h2 className="text-5xl lg:text-6xl font-light mb-8 leading-tight">
            Our{' '}
            <span className="font-normal">
              Factories
            </span>
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed font-light max-w-3xl mx-auto">
            Our strength comes from two specialized factories in China
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <div className="mb-8">
              <img
                src={factoryImages.huaxin}
                alt="Huaxin Fur Co., Ltd."
                className="w-full h-80 object-cover object-top"
              />
            </div>
            <h3 className="text-2xl font-medium mb-2">Huaxin Fur Co., Ltd.</h3>
            <p className="text-gray-700 leading-relaxed mb-2">
              Focused on down jackets, woven outerwear, PU, and faux fur.
            </p>
            <div className="space-y-1 text-sm text-gray-600">
              <div className="flex items-center">
                <i className="ri-check-line w-4 h-4 flex items-center justify-center text-teal-600 mr-3"></i>
                <span>Down Jackets Manufacturing</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line w-4 h-4 flex items-center justify-center text-teal-600 mr-3"></i>
                <span>Woven Outerwear Production</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line w-4 h-4 flex items-center justify-center text-teal-600 mr-3"></i>
                <span>PU & Faux Fur Specialization</span>
              </div>
            </div>
          </div>

          <div>
            <div className="mb-8">
              <img
                src={factoryImages.dongming}
                alt="Dongming Garments Co., Ltd."
                className="w-full h-80 object-cover object-top"
              />
            </div>
            <h3 className="text-2xl font-medium mb-2">Dongming Garments Co., Ltd.</h3>
            <p className="text-gray-700 leading-relaxed mb-2">
              Specialized in leather garments and shearling outerwear.
            </p>
            <div className="space-y-1 text-sm text-gray-600">
              <div className="flex items-center">
                <i className="ri-check-line w-4 h-4 flex items-center justify-center text-teal-600 mr-3"></i>
                <span>Leather Garments Expertise</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line w-4 h-4 flex items-center justify-center text-teal-600 mr-3"></i>
                <span>Shearling Outerwear</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-line w-4 h-4 flex items-center justify-center text-teal-600 mr-3"></i>
                <span>Premium Craftsmanship</span>
              </div>
            </div>
          </div>
        </div>

        
      </div>
    </section>
  );
}
